import React from "react";
import { FieldValues } from "react-hook-form";

import { ButtonModal, JsonForm, JsonFormControl } from "@components";
import { DocumentActions } from "@hooks";
import { convertDateToTimestamp } from "@utils";

type SetExpirationDateModalProps = {
  updateComponent: DocumentActions["update"];
};

function makeFormControl() {
  return [
    {
      label: "Expiration Date",
      inputType: "date",
      fieldName: "expirationDate",
      defaultValue: new Date(),
    },
  ] as JsonFormControl[];
}

export function SetExpirationDateModal({
  updateComponent,
}: SetExpirationDateModalProps) {
  const expirFormControl = React.useMemo(() => makeFormControl(), []);
  const submit = React.useCallback(
    (data: FieldValues) =>
      updateComponent({
        expirationDate: convertDateToTimestamp(new Date(data.expirationDate)),
      }),
    [updateComponent],
  );
  return (
    <ButtonModal
      title="Set Expiration Date"
      label="Set Expiration Date"
      size="sm"
    >
      <JsonForm
        fields={expirFormControl}
        onSubmit={submit}
        submitButtonText="Update"
      />
    </ButtonModal>
  );
}
